import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useOpenItemPage } from '#features/work-items/item-navigation';
import { BoardView } from '#features/board/components/board-view';
import { workItemSearchSchema, type WorkItemSearch } from '#features/work-items/search-schema';

const BoardRoute = () => {
  const { projectKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const openItemPage = useOpenItemPage();

  const onSearchChange = (patch: Partial<WorkItemSearch>): void => {
    void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: 'item' in patch });
  };

  return (
    <BoardView
      search={search}
      projectKey={projectKey}
      onSearchChange={onSearchChange}
      onExpand={openItemPage}
    />
  );
};

export const Route = createFileRoute('/_authed/$projectKey_/board')({
  validateSearch: workItemSearchSchema,
  component: BoardRoute,
});
